<style scoped lang="scss">
.modal-body {
    padding: 0;
}
.modal {
    z-index: 9999999;
}
.modal, .modal-backdrop {
    opacity: 0;
    transition: opacity 0.2s linear;

    &.open {
        display: block;
    }

    &.fadein {
        opacity: 1;
    }

    .modal-body {
        max-height: calc(100vh - 11.75rem);
        overflow: auto;
    }
}

.modal-backdrop {
    display: none;
    z-index: 999999;

    &.fadein {
        opacity: 0.5;
    }
}
</style>

<template>
    <div>
        <div class="modal" tabindex="-1" role="dialog" :class="{'fadein': modal.show, 'open': modal.open}" @click="close()">
            <div class="modal-dialog" role="document" @click="preventClose()">
                <div class="modal-content">
                    <div class="modal-header" v-if="showHeader">
                        <h5 class="modal-title">{{ modal.title }}</h5>
                        <button type="button" class="close" @click="close()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <!-- <div class="modal-body"> -->
                        <slot :close="close">
                            <p v-html="modal.message"></p>
                        </slot>
                    <!-- </div> -->
                    <div class="modal-footer" v-if="showFooter">
                        <slot name="footer" :close="close">
                            <button type="button" v-for="button in modal.buttons" :class="button.class" @click="close(button.value)" v-html="button.lable"></button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-backdrop" @click="close()" :class="{'fadein': modal.show, 'open': modal.open}"></div>
    </div>
</template>

<script>
    export default {

        props: {
            showHeader: {
                type: Boolean,
                default: true,
            },
            showFooter: {
                type: Boolean,
                default: true,
            },
        },

        data() {
            return {
                modal: undefined,
                promise: undefined,
                cancelClose: false,
                resolve: undefined,
            };
        },

        mounted() {
            this.$emit('initized', this);
        },
        created() {
            this.reset();
        },

        methods: {

            title(title) {
                this.modal.title = title;
                return this;
            },

            message(message) {
                this.modal.message = message;
                return this;
            },

            addButton(lable, className, value) {
                this.modal.buttons.push({
                    lable: lable,
                    class: className,
                    value: value,
                });
                return this;
            },

            show(callback) {
                this.promise = new Promise((resolve) => {
                    this.resolve = resolve;
                });

                if (callback) {
                    this.promise.then((response) => callback(response)).catch(() => {});
                }

                this.modal.open = true;
                setTimeout(() =>{
                    this.modal.show = true;
                }, 10);

                return this.promise;
            },

            confirm(callback) {
                this.addButton(this.trans.get('general.no'), 'btn btn-secondary', false)
                this.addButton(this.trans.get('general.yes'), 'btn btn-danger', true)

                return this.show(callback);
            },

            close(response) {
                if (this.cancelClose) {
                    return this;
                }

                this.resolve(response);

                this.modal.show = false;
                setTimeout(() =>{
                    this.modal.open = false;
                    this.reset();
                }, 200);

                return this;
            },

            reset() {
                this.modal = {
                    show: false,
                    open: false,
                    title: '',
                    message: '',
                    buttons: [],
                };
            },

            preventClose() {
                this.cancelClose = true;

                setTimeout(() => {
                    this.cancelClose = false;
                }, 100);
            }

        },

    }
</script>
